import { Component, Input, OnInit } from "@angular/core";
import { ReportCustomElement } from "../../../../models/report-preview/report-custom-element";
import { Notifier, OfflineReportPreviewService } from "../../../../../_services/offline-report-preview.service";

@Component({
  selector: "app-report-custom-element",
  templateUrl: "./report-custom-element.component.html",
  styleUrls: ["./report-custom-element.component.scss"],
  standalone: false
})
export class ReportCustomElementOfflineComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public customElementsKey: string;
  @Input() public elementLocation: string;

  public notifier: Notifier;
  public reportCustomElemet: ReportCustomElement;
  public resizeMarkerSize: number;
  public resizing: boolean;
  constructor(public designService: OfflineReportPreviewService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  ngOnInit(): void {
    this.notifier = {
      componentName: "report-custom-element.component",
      ids: { pageId: this.pageKey, elementId: this.customElementsKey }
    };
    this.reportCustomElemet = this.designService.getCustomElements(this.customElementsKey);
  }

  public onClick(event: MouseEvent) {}

  public getStyles(reportCustomElemet: ReportCustomElement): object {
    return {
      width: reportCustomElemet.width,
      height: reportCustomElemet.itemContainerHeight,
      fontSize: reportCustomElemet.fontSize,
      fontFamily: reportCustomElemet.fontFamily,
      border: `${reportCustomElemet.borderWidth} ${reportCustomElemet.borderStyle} ${reportCustomElemet.borderColor}`,
      padding: `${reportCustomElemet.itemMargin}mm`
    };
  }

  public getContainerStyle(reportCustomElemet: ReportCustomElement): object {
    return {
      top: reportCustomElemet.top,
      left: reportCustomElemet.left,
      width: reportCustomElemet.width,
      height: reportCustomElemet.height
    };
  }

  public getItemStyles(reportCustomElemet: ReportCustomElement): object {
    return {
      width: reportCustomElemet.width,
      height: reportCustomElemet.height,
      border: `${reportCustomElemet.borderWidth} ${reportCustomElemet.borderStyle} ${reportCustomElemet.borderColor}`,
      margin: reportCustomElemet.itemMargin
    };
  }
}
